import script from "./Retornos.vue?vue&type=script&setup=true&lang=ts"
export * from "./Retornos.vue?vue&type=script&setup=true&lang=ts"

import "./Retornos.vue?vue&type=style&index=0&id=40f19479&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f19479"]])

export default __exports__